export default __webpack_public_path__ + "static/media/Metal007_PREVIEW.ecf6f4fd.jpg";